var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('dialog-bus'),_c('snackbar-bus'),_c('notifications',{attrs:{"animation-type":"velocity","width":"300px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }